import React from 'react'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input} from 'reactstrap'
import axios from "axios/index"

export default class ContactForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            formModal: false,
            thanksModal: false,
            error: null,
            sending: false,
            form: {
                name: '',
                email: '',
                message: ''
            }
        }
    }

    toggleModal = (name) => {
        this.setState({
            [name]: !this.state[name]
        })
    }

    handleInputChange = event => {
        this.setState({
            error: null,
            form: {
                ...this.state.form,
                [event.target.name]: event.target.value
            }
        })
    }

    submitForm = () => {
        this.setState({sending: true})
        axios.post('/contact/message', {
                data: {...this.state.form},
                authenticity_token: CSRF_TOKEN
            })
            .then(res => {
                //console.log(res);
                if(res.data.success){
                    this.setState({
                        formModal: false,
                        thanksModal: true,
                        sending: false
                    })
                } else {
                    this.setState({error: res.data.error, sending: false})
                }
            })
    }

    renderForm() {
        return (
            <Modal isOpen={this.state.formModal} toggle={() => this.toggleModal('formModal')}>
                <ModalHeader toggle={() => this.toggleModal('formModal')}>
                    {!this.state.error &&
                        <span>{this.props.t.form_title}</span>
                    }
                    {this.state.error &&
                        <span className="text-danger">{this.state.error}</span>
                    }
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="name">{this.props.t.name}</Label>
                            <Input type="text" name="name" id="name" onChange={this.handleInputChange} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="email">{this.props.t.email}</Label>
                            <Input type="email" name="email" id="email" onChange={this.handleInputChange} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="message">{this.props.t.message}</Label>
                            <Input type="textarea" name="message" id="message" onChange={this.handleInputChange} rows={10}/>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.submitForm} color="success" disabled={this.state.sending}>{this.props.t.submit}</Button>
                </ModalFooter>
            </Modal>
        )
    }

    renderThanks() {
        return (
            <Modal isOpen={this.state.thanksModal} toggle={() => this.toggleModal('thanksModal')}>
                <ModalHeader className="text-success" toggle={() => this.toggleModal('thanksModal')}>
                    {this.props.t.thanks_header}
                </ModalHeader>
                <ModalBody className="text-success">
                    {this.props.t.thanks_body}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => this.toggleModal('thanksModal')}>{this.props.t.thanks_close}</Button>
                </ModalFooter>
            </Modal>
        )
    }

    render() {
        return (
            <div>
                <div className="card h-100 border-primary" style={{cursor: 'pointer'}} onClick={() => this.toggleModal('formModal')}>
                    <div className="card-body">
                        <div className="text-center">
                            <h5 className="text-truncate">{this.props.t.box_title}</h5>
                        </div>
                        <div className="row">
                            <div className="col-3 pr-0" style={{minWidth: '70px'}}>
                                <img src="/images/contact/contact.png" className="img-fluid" />
                            </div>
                            <div className="col">
                                {this.props.t.box_text}
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderForm()}
                {this.renderThanks()}
            </div>
        )
    }
}